export default {"src":"/_next/static/media/mobileLogo.aacd7b94.svg","height":35,"width":38,"blurWidth":0,"blurHeight":0};